'use strict';

require('../scss/common.scss');

import $ from 'jquery';

// This allows angular to find jQuery on the window
window.$ = $;
window.jQuery = $;

import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import videogular from 'videogular';
import videogularControlls from 'videogular-controls';
import videogularBuffering from 'videogular-buffering';
import videogularOverlayPlay from 'videogular-overlay-play';
import videogularThemesDefault from 'videogular-themes-default';

import angularUtilsPagination from 'angular-utils-pagination';

import infiniteScroll from 'ng-infinite-scroll';

import {core} from 'site_core';

// Our Modules
import appRoutes from './app.routes';
import appRun from './app.run';

'ngInject';
var app = angular.module('site', [
  angularUtilsPagination,
  uiRouter,
  core.components,
  core.features,
  core.factories,
  core.filters,
  videogular,
  videogularControlls,
  videogularBuffering,
  videogularOverlayPlay,
  infiniteScroll,
]);

app.config(appRoutes);
app.run(appRun);

app.constant('BASE_URLS', {API: API_URL, CONTENT: CONTENT_URL});

app.constant('siteConst', {
	id: 15,
  urlShort: 'SpankMyBottom.com',
  urlLong: 'http://www.SpankMyBottom.com',
  urlMed: 'www.SpankMyBottom.com',
  name: 'Spank My Bottom',
  tagline: '',
  footerTagline: 'Check out the latest F/F Spanking video downloads that have been added to our massive members area! Miss Elizabeth Simpson knows exactly how to deal with disobedient Young Ladies & Naughty School Girls. Usually after a good telling off bottoms are bared and then thrashed hard! ',
  logoLarge: 'images/smb_logo_red.png',
  logoSmall: 'images/smb_logo_red.png',
  twoTwoFiveSevenAddress: '5400 W. 64th Ave Arvada, CO 80007',
  webmasterEmail: 'webmaster@xerotics.com',
  metaDescription: 'Female School girl caning video downloads naughty girls caned hard on the bare bottom with knickers down',
  tour: {
    updates: 12,
    comingSoon: 3,
    models: 24
  },
  advert: {
    tour: [
      'Elizabeth Simpson and Rosaleen Young',
      'Exclusive F/F Spanking Videos',
      'Full Updates Twice a Week',
      'Unlimited Streaming and Downloads',
      'HD/SD Mobile and Tablet Ready',
    ],
    trailer: [
      'F/F Schoolgirl Canings',
      'Exclusive Rosaleen Young Videos',
      'Full Updates Twice a Week',
      'Unlimited Streaming and Downloads',
      'HD/SD Mobile and Tablet Ready',
      'Classic British Discipline',
      'Domestic Discipline Punishments',
      'Schoolgirl Caning and Strappings',
      'Exotic Spanking Photos',
    ]
  }
});



// WEBPACK FOOTER //
// ./src/app/app.js